import React from 'react';
import { TrashIcon, XMarkIcon } from '@heroicons/react/24/outline';

type DeleteLeadsBulkConfirmModalProps = {
  isOpen: boolean;
  count: number;
  onClose: () => void;
  onConfirm: () => void;
  deleting: boolean;
};

const DeleteLeadsBulkConfirmModal: React.FC<DeleteLeadsBulkConfirmModalProps> = ({
  isOpen,
  count,
  onClose,
  onConfirm,
  deleting,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" aria-hidden="true" onClick={onClose} />
      <div className="relative z-10 w-full max-w-sm rounded-xl bg-slate-800 border border-slate-600/50 shadow-xl">
        <div className="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-slate-700/50">
          <div className="flex items-center gap-2">
            <TrashIcon className="w-6 h-6 text-red-400" />
            <h2 className="text-lg font-semibold text-white">Delete Leads</h2>
          </div>
          <button type="button" onClick={onClose} className="p-1 text-gray-400 hover:text-white transition-colors rounded" disabled={deleting}>
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>
        <div className="px-4 sm:px-6 py-4">
          <p className="text-gray-300 text-sm">
            Are you sure you want to delete <span className="font-medium text-white">{count}</span> selected lead{count !== 1 ? 's' : ''}? This action cannot be undone.
          </p>
        </div>
        <div className="flex items-center justify-end gap-2 px-4 sm:px-6 py-4 border-t border-slate-700/50">
          <button
            type="button"
            onClick={onClose}
            disabled={deleting}
            className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={deleting}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-colors"
          >
            {deleting ? 'Deleting...' : `Delete ${count} lead${count !== 1 ? 's' : ''}`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteLeadsBulkConfirmModal;
